export default __webpack_public_path__ + "static/media/warning.1ada8d88.png";